let cartOpen = false;
document.addEventListener('DOMContentLoaded', onDOMContentLoaded);

function onDOMContentLoaded() {
    if (window.location.href.includes("/collections/bundle-and-save")) {
        let observer = new MutationObserver(onMutation);
        observer.observe(document.querySelector('.quick-cart'), { attributes: true });
        addListenersToAtcButtons();
        let productObserver = new MutationObserver(function () {
            addListenersToAtcButtons();
        });
        let productContainer = document.querySelector('.collection__infinite-container');
        if (productContainer) {
            productObserver.observe(productContainer, {
                childList: true,
                subtree: true
            });
        }
        let atcButtons = document.querySelectorAll('.visible-atc-btn');
        atcButtons.forEach(function (button) {
            button.addEventListener('click', onModalButtonClick);
            button.addEventListener('touchstart', onModalButtonClick);
        });
    }
}
function onMutation(mutationsList, observer) {
    mutationsList.forEach(function (mutation) {
        let quickCart = document.querySelector('.quick-cart');
        if (mutation.type === 'attributes' && quickCart.classList.contains('is-visible')) {
            if (cartOpen) {
                quickCart.classList.remove('is-active', 'is-visible');
                cartOpen = false; 
            }
        }
    });
}
function addListenersToAtcButtons() {
    let atcButtons = document.querySelectorAll('.visible-atc-btn');
    atcButtons.forEach(function (button) {
        if (!button.hasAttribute('data-listener-added')) {
            button.addEventListener('click', onModalButtonClick);
            button.addEventListener('touchstart', onAddToCartButtonClick);
            button.setAttribute('data-listener-added', 'true');
        }
    });
}
function onModalButtonClick() {
    let button = event.currentTarget;
    let modal = button.closest('.product-tile').querySelector('.js-sticky-visible-atc');
    if (modal) {
        let addToCartButtons = modal.querySelectorAll('.visible-atc-option');
        if (addToCartButtons) {
            addToCartButtons.forEach(function (addToCartButton) {
                if (!addToCartButton.hasAttribute('data-listener-added')) {
                    addToCartButton.addEventListener('click', onAddToCartButtonClick);
                    addToCartButton.addEventListener('touchstart', onAddToCartButtonClick);
                    addToCartButton.setAttribute('data-listener-added', 'true');
                }
            });
        }
    }
}
function onAddToCartButtonClick(event) {
    cartOpen = true;
}